import { FC, useMemo } from 'react';

import { Box, Divider, Typography } from '@mui/material';
import { useField } from 'formik';

import { Flex } from 'src/components/Flex';
import NPICurrencyInput from 'src/components/inputs/NPICurrencyInput/NPICurrencyInput';
import { useAdditionalTarrifs } from 'src/hooks';
import { ADDITIONAL_TARIFFS_PERSONAL_CARDS } from 'src/pages/AddTransactionPricingPage/sections/AdditionalTariffs';

import { CustomGridItem } from './components';
import { GridHeader } from './GridHeader';

interface AdditionalTariffsProps {
    name: string;
    editable?: boolean;
}

const AdditionalTariffs: FC<AdditionalTariffsProps> = ({ name, editable }) => {
    const [{ value: additionalTariffs }] = useField(name);
    const { editableFields } = useAdditionalTarrifs();

    const displayOptions = useMemo(() => {
        return Object.keys(additionalTariffs).map((additionalTariff) => {
            const additionalTarrifChargeDefault = ADDITIONAL_TARIFFS_PERSONAL_CARDS.find((el) => {
                return el.name === additionalTariff;
            });

            const editableField = editableFields.find((field) => {
                return field.name === additionalTariff;
            });

            const option = {
                name: additionalTariff,
                label: additionalTarrifChargeDefault?.heading ?? '',
                isEditable: !!editableField,
                min: editableField?.min,
                max: editableField?.max,
            };

            return option;
        });
    }, [additionalTariffs]);

    return (
        <Box>
            <Typography fontSize="24px" color="#434341" marginBottom="8px">
                Additional Tariffs Table
            </Typography>
            <Divider
                sx={{
                    borderColor: 'warning.main',
                    marginBottom: '34px',
                }}
            />
            <GridHeader additionalTarrifs />

            {displayOptions.map((option) => {
                return (
                    <CustomGridItem
                        key={option.name}
                        item1={<Typography>{option.label}</Typography>}
                        item2={
                            <Flex gap="24px">
                                <NPICurrencyInput
                                    name={`${name}.${option.name}`}
                                    disabled={editable ? !option.isEditable : true}
                                    handleValue={(valueInCents) => {
                                        additionalTariffs[option.name] = valueInCents;
                                    }}
                                    defaultValueInCents={additionalTariffs[option.name]}
                                    min={option?.min}
                                    max={option?.max}
                                />

                                <Flex sx={{ opacity: 0 }} />
                            </Flex>
                        }
                        columns={2}
                    />
                );
            })}
        </Box>
    );
};

export default AdditionalTariffs;
